module.exports = __webpack_public_path__ + "static/img/davidova.7939b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/davidova.jpg
// module id = 186
// module chunks = 1